export default __webpack_public_path__ + "static/media/collapse-arrow-right.c82e47f0.svg";